import { render } from "./RowButton.vue?vue&type=template&id=4609cda7"
import script from "./RowButton.vue?vue&type=script&lang=js"
export * from "./RowButton.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__